//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        resident: {
            required: true,
            type: Object
        },
        isBlacklisted: {
            required: true,
            type: Boolean,
            default: false
        },
        isUserExist: {
            required: true,
            type: Boolean,
            default: false
        },
        hideLease: {
            required: true,
            default: 1
        },
        moveOutLease: {}
    },
    data: function data() {
        return {
            menuOpened: false,
            allowedRoles: ['super-admin', 'corporate-admin', 'accounting-admin', 'marketing-admin', 'property-manager', 'regional-manager', 'leasing-consultant']
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('undo-renewal-lease', function (item, response) {
            _this.undoRenewLease(response);
        });
        Event.$on('delete-entry-move-in', function (item, response) {
            _this.undoMoveInMessage(response);
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('undo-renewal-lease');
        Event.$off('delete-entry-move-in');
    },

    methods: {
        sendNotification: function sendNotification() {
            Event.$emit('new-notification');
        },
        addViolation: function addViolation() {
            Event.$emit('resident-add-violation');
        },
        addTransaction: function addTransaction() {
            Event.$emit('show-gl-wizard', this.resident);
        },
        residentAddPayment: function residentAddPayment() {
            Event.$emit('resident-add-payment');
        },
        confirmInvitation: function confirmInvitation() {
            Event.$emit('resident-confirm-portal-invite');
        },
        confirmBlacklist: function confirmBlacklist() {
            Event.$emit('resident-confirm-blacklist');
        },
        renewLease: function renewLease() {
            Event.$emit('resident-renew-lease', this.resident);
        },
        transferUnit: function transferUnit() {
            Event.$emit('resident-transfer-unit', this.resident);
        },
        openSlider: function openSlider(link) {
            Event.$emit(link);
            this.menuOpened = false;
        },
        undoLeaseRenewal: function undoLeaseRenewal() {
            var payload = {
                resident_id: this.resident.id
            };
            Event.$emit('confirm-delete', payload, '/prototype/person/resident/undo-renewal-lease', 'undo-renewal-lease', 'Are you sure you want to Cancel renew lease?', 'Undo Renewal');
        },
        undoRenewLease: function undoRenewLease(response) {
            if (response.data.error) {
                this.$snotify.error('Error removing renewal lease: ' + response.data.error);
            } else {
                this.$snotify.success('The renewal lease has been removed');
                Event.$emit('resident-list-dashboard-updated');
                Event.$emit('refresh-resident-dashboard', this.resident);
            }
        },
        undoMoveInMessage: function undoMoveInMessage(response) {
            console.log(response);
            if (response.data.error) {
                this.$snotify.error(response.data.error);
            } else {
                Event.$emit('delete-entry');
            }
        },
        undoTransferUnit: function undoTransferUnit() {
            var _this2 = this;

            var payload = {
                resident_id: this.resident.id
            };

            axios.post('/prototype/person/resident/undo-transfer-lease', payload).then(function (response) {
                if (response.data.error) {
                    _this2.$snotify.error('Error removing transfer lease: ' + response.data.error);
                } else {
                    _this2.$snotify.success('Unit transfer successfully undone. The transfer lease has been removed');
                    Event.$emit('resident-list-dashboard-updated');
                    Event.$emit('refresh-resident-dashboard', _this2.resident);
                }
            });
        },
        undoMovein: function undoMovein(item) {
            Event.$emit('confirm-delete', item, '/prototype/person/residents/move-ins/' + item.latest_move_in_event.id_move_in_events, 'delete-entry-move-in', 'Are you sure you want to Cancel this Move-In? This will delete all resident information (though the Applicant information will remain)', 'CANCEL MOVE-IN', '', 'delete');
            Event.$emit('close-resident-dashboard');
        }
    },
    computed: {
        isPermittedToTransferResident: function isPermittedToTransferResident() {
            return this.allowedRoles.includes(window.user.role);
        },
        isAdmin: function isAdmin() {
            return window.user.role === 'super-admin' || window.user.role === 'corporate-admin';
        },
        canRenewLease: function canRenewLease() {
            return this.hideLease && this.resident.lease && !this.resident.has_renewal_lease && !this.resident.has_transfer_lease && !this.resident.do_not_renew_lease;
        },
        canUndoRenewal: function canUndoRenewal() {
            return this.isAdmin && this.hideLease && this.resident.has_renewal_lease;
        },
        isOnNotice: function isOnNotice() {
            return this.resident.current_status !== 'Active';
        },
        isMovedOut: function isMovedOut() {
            return this.resident.current_status.toLowerCase() === 'move out';
        },
        canTransferResident: function canTransferResident() {
            return this.isPermittedToTransferResident && this.resident.lease && !this.resident.transfer_resident && !this.resident.has_transfer_lease && !this.resident.has_renewal_lease;
        },
        canUndoTransferResident: function canUndoTransferResident() {
            return this.isAdmin && (this.resident.has_transfer_lease || this.resident.transfer_resident);
        },
        isFutureResident: function isFutureResident() {
            return this.resident.current_status === 'Future';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/ResidentActionsMenu.vue
// module id = yrSZ
// module chunks = 0 1